import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import styles from "./ComponentManagement.module.css";
import { useNavigate } from "react-router-dom";
import actionicon from "../../../../../assets/images/actionicon.svg";
import {
  Dropdown,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import { ReactComponent as ViewIcon } from "../../../../../assets/images/view.svg";
import { ReactComponent as ArchiveIcon } from "../../../../../assets/images/archive.svg";

import { ReactComponent as EditIcon } from "../../../../../assets/images/editIcon.svg";

const { Option } = Select;

const ComponentManagement = () => {
  const navigate = useNavigate();
  const [isModal, setIsModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  const [ReasonFilter, setReasonFilter] = useState({
    value: "Brunt",
    id: 1,
  });

  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "No",
    },
    {
      title: "Component Name",
      dataIndex: "ComponentName",
      key: "ComponentName",
      render: (text, record) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
          {(record.ComponentName === "Pie Crust Dough" ||
            record.ComponentName === "Choux Pastry Shells" ||
            record.ComponentName === "Brownie Base" ||
            record.ComponentName === "Cookie Dough" ||
            record.ComponentName === "Tart Shells") && (
            <img src={actionicon} alt="icon" className={styles.iconImg} />
          )}
        </div>
      ),
    },
    {
      title: "Product Tag",
      key: "ProductTag",
      dataIndex: "ProductTag",
    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      key: "Quantity",
    },
    {
      title: "Shelf-life",
      key: "ShelfLife",
      dataIndex: "ShelfLife",
    },
    {
      title: "Action",
      key: "Action",
      dataIndex: "Action",
      render: (text) => (
        <div className={styles.itemsButtonDiv}>
          <ViewIcon
            className={styles.itemsButton}
            onClick={() => navigate("/Warehouse/ComponentMGMT/CreateComponent")}
          />

          <EditIcon
            className={styles.itemsButton}
            onClick={() => navigate("/productionManagement/ReciepeBuilder")}
          />
          <ArchiveIcon
            className={styles.itemsButton}
            onClick={() => setIsModal(true)}
          />
        </div>
      ),
    },
  ];

  const data = [
    {
      No: "1",
      ComponentName: "Pie Crust Dough",
      Quantity: "2 lbs",
      ProductTag: "Cake ",
      ShelfLife: "180 days",
    },
    {
      No: "2",
      ComponentName: "Choux Pastry Shells",
      Quantity: "36 oz",
      ProductTag: "Cookies",
      ShelfLife: "2 years",
    },
    {
      No: "3",
      ComponentName: "Pizza Dough Balls",
      Quantity: "3 lbs",
      ProductTag: "bread",
      ShelfLife: "12 months",
    },
    {
      No: "4",
      ComponentName: "Brownie Base",
      Quantity: "4 g",
      ProductTag: "Cake",
      ShelfLife: "180 days",
    },
    {
      No: "5",
      ComponentName: "Sponge Cake Layers",
      Quantity: "36 oz",
      ProductTag: "Cookies",
      ShelfLife: "2 years",
    },
    {
      No: "6",
      ComponentName: "Shortbread Base",
      Quantity: "3 lbs",
      ProductTag: "bread",
      ShelfLife: "12 months",
    },
    {
      No: "7",
      ComponentName: "Cookie Dough",
      Quantity: "2 lbs",
      ProductTag: "bread",
      ShelfLife: "12 months",
    },
    {
      No: "8",
      ComponentName: "Bread Dough",
      Quantity: "4 g",
      ProductTag: "Cake",
      ShelfLife: "180 Days",
    },
    {
      No: "9",
      ComponentName: "Tart Shells",
      Quantity: "3 lbs",
      ProductTag: "Cookies",
      ShelfLife: "2 years",
    },
  ];

  const handleDisplayFilter = () => {
    setShowFilter(true);
  };

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        showFilterIcon={true}
        onClickFilter={() => handleDisplayFilter()}
        heading={"Component Management"}
        onSearch={(e) => console.log(e.target.value)}
        onSubmit={() => navigate("/productionManagement/ReciepeBuilder")}
        submitButtonText={"Create Component"}
        // showBackIcon={true}
        showSubmitButton={true}
        showSearch={true}
      />

      <div className={styles.subCont}>
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="No"
          />
        </div>
      </div>
      <Modal
        open={isModal}
        onClickOkButton={() => {
          setIsModal(false);
        }}
        onCancel={() => setIsModal(false)}
        className={styles.modalCont}
        title={"Archive"}
        headingClass={styles.modalHeading}
        width={"400px"}
        onClickCancelButton={() => setIsModal(false)}
        okBtnTitle={"Yes"}
        twoButton
        cancelBtnTitle={"No"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        onBtnPress={() => setIsModal(false)}
      >
        <div>
          <TextComponent
            text="Are you sure you want to archive? "
            className={styles.CardText}
          />
        </div>
      </Modal>

      {/* Filter Modal  */}
      <Modal
        open={showFilter}
        onClickOkButton={() => {
          setShowFilter(false);
        }}
        onCancel={() => setShowFilter(false)}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        twoButton
        onBtnPress={() => setShowFilter(false)}
        onClickCancelButton={() => setShowFilter(false)}
        okBtnTitle={"Apply Filters"}
        cancelBtnTitle={"Reset All"}
      >
        <Dropdown
          className={styles.input}
          label={"Reason"}
          labelClass={styles.labelClass}
          value={ReasonFilter}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Brunt",
              id: 1,
            },
            {
              value: "Expired",
              id: 2,
            },
            {
              value: "Spoilt",
              id: 3,
            },

            {
              value: "Expired",
              id: 4,
            },
          ]}
          onChange={(e) => setReasonFilter(e)}
        />
      </Modal>
    </div>
  );
};

export default ComponentManagement;
